const state = {
    newMessagesCount: null,
    dashNotification: null,
    importantMessagesCount: null,
    list: [],
    selectedItem: null,
    pagination: {
        offset: 1,
        total_pages:1,
        limit: 10
    }
}
const actions = {
    async getNotifications({commit}, opts) {
        let geco = opts.grupoEconomico? opts.grupoEconomico : this.state.permissions.grupoEconomico
        if (!geco) return;
        let obj = {
            query: [
                {
                    Modulo: "Portal",
                    Acao: "getnotifications",
                    Payload: {
                        grupo_economico: geco,
                        filter: opts.filter || null, // Avaliar necessidade no futuro
                        prioridade_alta: opts.prioridade_alta || null, // Avaliar necessidade no futuro
                        modulo: opts.modulo ||null, // Avaliar necessidade no futuro
                        prestador_id: opts.prestador_id || null,
                        offset: opts.offset || 1,
                        limit: opts.limit
                    },
                },
            ],
        }
        await this.dispatch("request/doRequest", obj).then((response) => {
            if (!response || response.isAxiosError || !response.sucesso) {
                commit('updateNotifications', 
                    { 
                    list: [], 
                    newMessagesCount:0, 
                    importantMessagesCount:0, 
                    pagination: {
                        offset: 1,
                        total_pages: 0,
                        limit: 10
                        }
                    }
                )
                this.commit("hideLoader");
                return;
            }

            let pagination = {
                offset: response.current_page,
                total_pages: response.total_pages,
                limit: 10
            }
            let list = response.dados
            let newMessagesCount =  response.total_nao_lidas
            let importantMessagesCount = response.dados.filter(
                    (msg) => msg.prioridade_alta
                ).length
            commit('updateNotifications',{ list, newMessagesCount, importantMessagesCount, pagination })
            return response
        });
    },
}

const mutations = {
    updateNotifications(state, data) {
        let { newMessagesCount, importantMessagesCount, list, pagination } = data
        state.newMessagesCount = newMessagesCount ? newMessagesCount : null
        state.importantMessagesCount = importantMessagesCount ? importantMessagesCount : null
        state.list = list ? list : []
        state.pagination = pagination
    },
    selectDashboardNotification(state, notification) {
        state.dashNotification = notification ? notification : null
    }
}
export default {
    namespaced: true,
    root: true,
    actions,
    mutations,
    state,
};